import graphqlRequest from "Services/assignment/assignmentRequest";
import {
  ENTITY_TYPE,
  GRADES,
  TEMPLATE_TO_ACTIVITYTYPE
} from "Services/assignment/constants";
import GET_ASSIGNMENT_TEMPLATE from "./graphql";

export async function getAssignmentTemplate(payload) {
  const {entityId, entityType=ENTITY_TYPE.DISTRICT, grade, defaultEntities} = payload
  const response = await graphqlRequest(GET_ASSIGNMENT_TEMPLATE, {
    entityId,
    entityType,
    grade,
    defaultEntities
  });
  return response.assignmentTemplate;
}


export async function getDefaultTemplates(entityId,entityType=ENTITY_TYPE.DISTRICT,defaultEntities){
  let templatePromises = [];
  for(let i=0;i<GRADES.length;i++){
    let aTemplate = getAssignmentTemplate({grade: GRADES[i], entityId, entityType,defaultEntities});
    templatePromises.push(aTemplate);
  }
  const templates = await(Promise.all(templatePromises));
  return Promise.resolve(templates);
}